export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10399.186a347f.jpg";